<template>
    <div class="mb-10">
        <ManageAvailability
            :availability-id="availability.id"
            :availability-name="availability.name"
            :days="days"
            :autosave="true"
        >
        </ManageAvailability>
    </div>
</template>

<script setup lang="ts">
import ManageAvailability from "../../Availabilities/components/ManageAvailability.vue";
import { useEditableDays } from "../../Availabilities/composables/useEditableDays";

const props = defineProps({
    availability: {
        type: Object,
        required: true,
    },
});

const { days } = useEditableDays(props.availability);
</script>
